import classNames from "classnames";
import Image from "next/image";
import SVGCheckBoxActive from "@/images/svg/check.svg";
import React, { Dispatch, SetStateAction } from "react";

export interface CheckboxProps {
  label: string;
  answer: any;
  setAnswer: Dispatch<SetStateAction<any>>;
  id: string;
  name: string;
  type: string;
  setValue?: any;
}

export default function Checkbox({
  label,
  setAnswer,
  answer,
  id,
  name,
  type,
  setValue,
}: CheckboxProps) {
  function onChange(e: any) {
    if (type === "radio") {
      if (e.target.value) {
        setValue(e.target.value);
        if (!answer.some((i: any) => i.title === e.target.name)) {
          setAnswer([
            ...answer,
            { title: e.target.name, value: e.target.value },
          ]);
        } else {
          setAnswer([
            ...answer.filter((i: any) => i.title !== e.target.name),
            { title: e.target.name, value: e.target.value },
          ]);
        }
      }
    } else if (type === "checkbox") {
      if (e.target.checked) {
        setAnswer([
          ...answer,
          { title: e.target.name, value: e.target.checked },
        ]);
      } else {
        setAnswer(answer.filter((i: any) => i.title !== e.target.name));
      }
    }
  }

  return (
    <div
      className={classNames(
        type === "radio" ? "checkbox-radio" : "checkbox-default"
      )}
    >
      <input
        type={type}
        id={id}
        name={name}
        value={label}
        onChange={(e: any) => onChange(e)}
      />
      <label htmlFor={id} className="form-check-label">
        {label}
        <div
          className={classNames(
            "box",
            type === "radio" ? "checkbox-radio" : "checkbox-default"
          )}
        >
          <Image
            src={SVGCheckBoxActive}
            width={10}
            height={10}
            alt={"checkbox"}
            className={"object-contain"}
          />
        </div>
      </label>
    </div>
  );
}
